import React, {useState, useEffect, useMemo} from 'react';
import { IonPage, IonContent, IonHeader, IonToolbar, IonButton, IonButtons, IonTitle, IonBackButton, IonIcon,IonFooter, IonSlides, IonSlide, IonAlert, IonSpinner, IonLoading} from '@ionic/react';
import {arrowBack, camera, trash} from 'ionicons/icons';
import './TripAuthorization.scss';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {useParams} from 'react-router-dom';
import {getTripById, closeOrder} from '../../../../actions/w_trip';
import SignaturePad from 'react-signature-pad-wrapper';
import QrReader from 'react-qr-reader';
import { validateQR } from './validator';
import srcToFile from "../../../../helpers/srcToFile";
import Swal from 'sweetalert2';
import S3Provider from '../../../../helpers/S3Provider';
import Axios from 'axios';
import { client } from '../../../../store';

const TripAuthorizationScreen = ({trip, isLoading, notification, packageUpdated, getTripById, history, user}) => {
  const isProofOfLoadingActive = useMemo(() => {
    try {
      const userFromStorage = localStorage.getItem('USER_PAYLOAD');
      const userParsed = userFromStorage ? JSON.parse(userFromStorage) : null;
      const settingsStr = userParsed?.company?.config?.settings;
      if (settingsStr) {
        const settings = JSON.parse(settingsStr);
        return settings?.proof_of_loading?.is_active === true;
      }
    } catch (e) {
      console.error("Error parsing user settings from localStorage", e);
    }
    return false;
  }, []);

  const slides = useMemo(() => {
    const s = [];
    s.push({ title: 'SCAN QR CODE', showQrReader: true });
    if (isProofOfLoadingActive) {
      s.push({ title: 'PROOF OF LOADING' });
    }
    s.push({ title: 'TANDA TANGAN ANDA' });
    s.push({ title: 'TANDA TANGAN PENGEMUDI' });
    return s;
  }, [isProofOfLoadingActive]);

  const [adminSignaturePad, setAdminSignaturePad] = useState();
  const [driverSignaturePad, setDriverSignaturePad] = useState();
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState();
  const [slider, setSlider] = useState();
  const [isQrError, setIsQrError] = useState('');
  const [showQrReader, setShowQrReader] = useState(slides[0]?.showQrReader || false);
  const [screenTitle, setScreenTitle] = useState(slides[0]?.title);
  const [showLoading, setShowLoading] = useState(false);
  const [selectedPhotos, setSelectedPhotos] = useState([]);
  const {id} = useParams();
  const slideOpts = {
    initialSlide: 0,
    speed: 400,
    allowTouchMove: false
  };

  useEffect(() => {
    if (packageUpdated === true) {
      Swal.fire({
        title: 'Sukses',
        text: "Barang berhasil dimuat  ke kendaraan dan telah diverifikasi Pengemudi",
        type: 'success',
        showCancelButton: false,
        confirmButtonText: 'TUTUP',
        confirmButtonClass: 'swal-update-package',
      }).then((result) => {
        history.push('/warehouse/trips');
      });
    }
  }, [packageUpdated])

  const initSlider = (el) => {
    // fix slider not rendered correctly
    el.target.swiper.update();
    setSlider(el.target.swiper);
  };

  const clearSignature = (signaturePad) => () => {
    if (signaturePad) {
      signaturePad.clear();
    }
  };

  const uploadSignature = async (signature, type) => {
    const signatureData = signature.toDataURL();
    const timestamp = new Date();
    const file = await srcToFile(signatureData, `signature_${type}_` + timestamp.getTime() + '.jpg', "image/jpeg")
    const fileUrl = await S3Provider.upload(file);

    return fileUrl;
  }



  const handlePhotoChange = async (e) => {
    const target = e.target;
    if (!target || !target.files) return;

    const files = Array.from(target.files);
    target.value = ''; // Clear immediately after capturing files

    const newPhotos = await Promise.all(
      files.map(async (file) => {
        return new Promise((resolve) => {
          const reader = new FileReader();
          reader.onload = (event) => {
            resolve({
              file,
              preview: event.target.result
            });
          };
          reader.readAsDataURL(file);
        });
      })
    );
    setSelectedPhotos([...selectedPhotos, ...newPhotos]);
  };

  const removePhoto = (index) => {
    const newPhotos = [...selectedPhotos];
    newPhotos.splice(index, 1);
    setSelectedPhotos(newPhotos);
  };

  const createAlert = message => {
    setAlertMessage(message);
    setShowAlert(true);
  };

  const setSlideProperty = () => {
    if (slider) {
      let index = slider.activeIndex;
      let slideProperty = slides[index];
      if (slideProperty) {
        setScreenTitle(slideProperty.title);
        setShowQrReader(slideProperty.showQrReader || false);  
      }
    }
  }
  
  const goToNextSlide = () => {
    if (slider) {
      const currentSlide = slides[slider.activeIndex];
      if (currentSlide.title === 'PROOF OF LOADING') {
        if (selectedPhotos.length === 0) {
          createAlert('Minimal unggah 1 foto Proof of Loading');
        } else {
          slider.slideNext();
          setSlideProperty();
        }
      } else if (currentSlide.title === 'TANDA TANGAN ANDA') {
        if (adminSignaturePad.isEmpty()) {
          createAlert('Tanda tangan admin tidak boleh kosong');
        } else {
          slider.slideNext();
          setSlideProperty();
        }
      } else if (currentSlide.title === 'SCAN QR CODE') {
          slider.slideNext();
          setSlideProperty();
      } else if (currentSlide.title === 'TANDA TANGAN PENGEMUDI') {
         if (driverSignaturePad.isEmpty()) {
          createAlert('Tanda tangan driver tidak boleh kosong');
        } else {
          slider.slideNext();
          setSlideProperty();
        }
      }
    }
  }
  
  const authorizeTrip = async () => {
    if (driverSignaturePad.isEmpty()) {
      createAlert('Tanda tangan driver tidak boleh kosong');
    } else {
      setShowLoading(true);
      try {
        const adminSignature = await uploadSignature(adminSignaturePad, 'admin');
        const driverSignature = await uploadSignature(driverSignaturePad, 'driver');

        const proofOfLoadingUrls = await Promise.all(
          selectedPhotos.map(async (photo, idx) => {
            const dataUrl = photo.preview;
            if (dataUrl.startsWith("http")) return dataUrl;

            const timestamp = new Date().getTime();
            const userId = user?.id || "";
            const fileName = `warehouse_proof_${id}_${userId}_${timestamp}_${idx}.jpg`;
            const file = await srcToFile(dataUrl, fileName, "image/jpeg");
            const fileUrl = await S3Provider.upload(file);
            return fileUrl;
          })
        );
        
        const additionalDocs = [
          {
            image_url: adminSignature,
            remarks: "admin warehouse " + user.name
          },
          {
            image_url: driverSignature,
            remarks: "driver warehouse " + (trip.driver && trip.driver.name) 
          },
          ...proofOfLoadingUrls.map(url => ({
            image_url: url,
            remarks: "Proof of Loading - Warehouse"
          }))
        ];

        const orders = [];
        trip.orders.map(order => {
          orders.push(client.put('orders/' + order.id, {
            additional_documents: additionalDocs
          }))
        })
        const resPutOrders = await Axios.all(orders);
        setShowLoading(false);
        if (resPutOrders.some(r => r.status === 200)) {
          Swal.fire({
            title: 'Sukses',
            text: 'Barang berhasil dimuat ke kendaraan dan telah diverifikasi oleh Pengemudi',
            icon: 'success',
            confirmButtonText: 'TUTUP',
            confirmButtonColor: '#cecece'
          }).then(() => {
            history.push('/warehouse/trips');
          })
        } else {
          throw new Error('Gagal update orders');
        }
      } catch (error) {
        setShowLoading(false);
        Swal.fire({
          title: 'Gagal',
          text: 'Terjadi kesalahan saat mengunggah data',
          icon: 'error',
          confirmButtonText: 'TUTUP',
          confirmButtonColor: '#cecece'
        })
      }
    }
  }

  const goToPrevSlide = () => {
    if (slider) {
      if (slider.activeIndex !== 0) {
        slider.slidePrev();
        setSlideProperty();
      }
    }
  }

  useEffect(() => {
    if (!trip) {
      history.push(`/warehouse/trip/${id}`);
    }
  }, [trip]);

  useEffect(() => {
  }, [adminSignaturePad]);


  useEffect(() => {
  }, [driverSignaturePad]);

  const handleScan = data => {
    if (data) {
      try {
        data = JSON.parse(data);
      } catch (e) {
      }

      if (validateQR(data, process.env.REACT_APP_KEY)) {
        if (data && data.data && data.data.value && data.data.value === id) {
          goToNextSlide();
        } else {
          createAlert('Trip tidak valid, trip terbaca: ' + data.data.value);
        }
      } else {
        createAlert('QR tidak valid');
      }
    }
  }

  const handleError = err => {
    setIsQrError(err);
    createAlert(`Pastikan Anda mengizinkan untuk menggunakan kamera perangkat Anda. ${err}`);
  };

  return (
  <IonPage>
    <IonAlert 
      isOpen={showAlert}
      onDidDismiss={() => setShowAlert(false)}
      header="Peringatan"
      message={alertMessage}
      buttons={['Oke']}
    />
    <IonHeader>
      <IonToolbar className="ritase-toolbar">
        <IonButtons slot="start">
          { (!slider || (slider && slider.activeIndex === 0)) && <IonBackButton defaultHref={`/warehouse/trip/${id}`} color="primary"></IonBackButton> }
          { slider && (slider.activeIndex >= 1) && <IonButton onClick={goToPrevSlide} color="primary" expand="block" shape="round"><IonIcon icon={arrowBack}/></IonButton> }
        </IonButtons>
        <IonTitle color="primary">{screenTitle}</IonTitle>
      </IonToolbar>
    </IonHeader>
    <IonContent style={{textAlign: 'left'}}>
      <IonLoading
        isOpen={showLoading}
        onDidDismiss={() => setShowLoading(false)}
        message={'Loading...'}
      />
      {trip && trip.orders && trip.orders.length > 0 && (
        <div style={{ padding: '16px', textAlign: 'center', backgroundColor: '#fff', borderBottom: '1px solid #e0e0e0' }}>
          <strong>Shipment Number: {trip.orders.map(order => order.shipment_number).filter(Boolean).join(', ')}</strong>
        </div>
      )}
      <IonSlides pager={true} options={slideOpts} autoplay={0} loop={false} style={{height: '100%'}} onIonSlidesDidLoad={initSlider}>
        <IonSlide>
          <div>
              <h4 className="instruction">Silakan scan QR Code pengemudi</h4>
            <div className="qr-reader-box">
              {!isQrError && showQrReader && <QrReader
                delay={1000}
                onError={handleError}
                onScan={handleScan}
                style={{ width: '100%', marginTop: 86 }}
              />}

              {!isQrError && <p>Arahkan QR code driver ke kotak diatas</p>}
              {isQrError &&  `Terjadi kesalahan ${isQrError}`}
            </div>
          </div>
        </IonSlide>
        {isProofOfLoadingActive && (
          <IonSlide>
            <div style={{ padding: '0 20px', width: '100%' }}>
              <h4 className="instruction">Silakan unggah foto Proof of Loading (Minimal 1)</h4>
              <input
                type="file"
                multiple
                accept="image/*"
                style={{ display: 'none' }}
                id="proof-of-loading-input"
                onChange={handlePhotoChange}
                capture="environment"
              />
              <IonButton expand="block" onClick={() => document.getElementById('proof-of-loading-input').click()}>
                <IonIcon icon={camera} slot="start" />
                AMBIL FOTO
              </IonButton>

              <div className="photo-preview-container">
                {selectedPhotos.map((photo, index) => (
                  <div key={index} className="photo-preview">
                    <img src={photo.preview} alt={`Proof ${index}`} />
                    <IonButton color="danger" className="remove-photo-btn" onClick={() => removePhoto(index)}>
                      <IonIcon icon={trash} />
                    </IonButton>
                  </div>
                ))}
              </div>
            </div>
          </IonSlide>
        )}
        <IonSlide>
          <div>
            <h4 className="instruction">Silakan berikan tanda tangan Anda di bawah ini</h4>
            <div className="signature-box">
            
            <SignaturePad redrawOnResize={true} ref={ref => setAdminSignaturePad(ref)}/>
            <div className="reset-box">
              <IonButton expand="full" className="reset-button" color="light" size="small" onClick={clearSignature(adminSignaturePad)}>ULANGI</IonButton>
            </div>
            </div>
          </div>
        </IonSlide>
        <IonSlide>
          <div>
              <h4 className="instruction">Silahkan minta tanda tangan pengemudi di bawah ini untuk menyelesaikan muat barang.</h4>
            <div className="signature-box">
            <SignaturePad redrawOnResize={true} ref={ref => setDriverSignaturePad(ref)}/>
            <div className="reset-box">
              <IonButton expand="full" className="reset-button" color="light" size="small" onClick={clearSignature(driverSignaturePad)}>ULANGI</IonButton>
            </div>
            </div>
          </div>
        </IonSlide>
    </IonSlides>
      
      
    </IonContent>
    <IonFooter>
        <IonToolbar>
          { slider && slides[slider.activeIndex] && (slides[slider.activeIndex].title === 'PROOF OF LOADING' || slides[slider.activeIndex].title === 'TANDA TANGAN ANDA') && (<IonButton expand="block" onClick={goToNextSlide}>
            Selanjutnya
          </IonButton>)}
          { slider && slides[slider.activeIndex] && slides[slider.activeIndex].title === 'TANDA TANGAN PENGEMUDI' && (<IonButton disabled={isLoading} expand="block" onClick={authorizeTrip}>
            {isLoading ? <IonSpinner color="light" /> : 'Selesai'}
          </IonButton>)}
        </IonToolbar>
      </IonFooter>
  </IonPage>
);
};

const mapStateToProps = ({w_trip, user}) => ({
  trip: w_trip.trip,
  isLoading: w_trip.isLoading,
  packageUpdated: w_trip.packageUpdated,
  user: user.data
});
const mapDispatchToProps = dispatch => bindActionCreators({ getTripById, closeOrder}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps) (TripAuthorizationScreen);